var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.489 6.81868C15.375 6.90869 13.3625 8.06281 13.3625 10.6291C13.3625 13.5974 15.9234 14.6475 16 14.6735C15.9882 14.7375 15.5932 16.1116 14.6498 17.5118C13.8086 18.7439 12.9301 19.974 11.5937 19.974C10.2572 19.974 9.91328 19.1839 8.37047 19.1839C6.86697 19.1839 6.33239 20 5.10994 20C3.88748 20 3.03452 18.8599 2.0538 17.4597C0.917823 15.8156 0 13.2613 0 10.8371C0 6.94869 2.48422 4.88649 4.92912 4.88649C6.22823 4.88649 7.31114 5.75458 8.12677 5.75458C8.90308 5.75458 10.1137 4.83448 11.5917 4.83448C12.1518 4.83448 14.1644 4.88649 15.489 6.81868ZM10.8901 3.18832C11.5013 2.45024 11.9337 1.42614 11.9337 0.40204C11.9337 0.260026 11.9219 0.116012 11.8963 0C10.9019 0.0380038 9.71871 0.674067 9.00528 1.51615C8.44515 2.16422 7.92237 3.18832 7.92237 4.22642C7.92237 4.38244 7.94792 4.53845 7.95971 4.58846C8.0226 4.60046 8.1248 4.61446 8.227 4.61446C9.11927 4.61446 10.2415 4.0064 10.8901 3.18832Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.b7dc4dd9a9c0520dc40df0d9cd36ca37.svg";
export { ForwardRef as ReactComponent };